module.exports = __webpack_public_path__ + "static/img/Logo_sdg1.c1da66f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Logo_sdg1.svg
// module id = 202
// module chunks = 13 35 38 42